<script>
    import {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import cart from '../stores/cart';
    import user from "../stores/user";
    import PasswordControl from "../components/controls/PasswordControl.svelte";
    import Warning from "../components/pages/Warning.svelte";
    import {setFocusTo, upCaseStr} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";

    let account = null;
    let showChangePassword = false;

    const setError = err => {
        if (err.code) {
            if (err.code === 'not_found' && err.params) {
                if (err.params.object === 'action') {
                    return "Το αίτημα αλλαγής κωδικού του λογαριασμού σας δεν είναι έγκυρο!";
                } else if (err.params === 'account') {
                    return "Δεν βρέθηκε λογαριασμός για αλλαγή κωδικού!";
                }
            } else if (err.code === 'not_allowed') {
                return "Το χρονικό όριο αυτού του συνδέσμου έχει λήξει!";
            } else if (err.message) {
                return err.message;
            }
        }

        return "Παρουσιάστηκε κάποιο σφάλμα κατά την διαδικασία αλλαγής κωδικού του λογαριασμού σας.";
    }

    const load = () => {
        const onSuccess = result => {
            account = result;
        }

        const onFailure = err => {
            // error = setError(err);
        };

        R.handle(R.account.details, {}, onSuccess, onFailure, LOADER.PAGE);
    }


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Ο λογαριασμός σας ενημερώθηκε.");
            if (showChangePassword) {
                toggleChangePassword();
            }
        }

        const onFailure = err => {
            if (err.code) {
                Alert.warning("Ενημέρωση λογαριασμού", err.message, () => {
                    if (err.params && err.params.field) {
                        setFocusTo(err.params.field);
                    }
                });
            }
        };

        if (!account.region_id || account.region_id == 0) {
            Notifier.showError("Δεν έχετε επιλέξει νομό!");
            setFocusTo("regionId");
            return;
        }

        R.handle(R.account.edit, account, onSuccess, onFailure, LOADER.POPUP);
    }

    const onRegionChange = () => {
        if (!$cart.region_id) {
            $cart.region_id = account.region_id;
            cart.saveCookie();
        }
    }

    const toggleChangePassword = () => {
        showChangePassword = !showChangePassword;
        if (showChangePassword) {
            setFocusTo("newPassword");
        } else {
            delete (account.new_password);
        }
    }

    const upCaseFields = () => {
        let fields = ['lastname', 'firstname', 'address', 'city'];

        fields.map(key => {
            account[key] = upCaseStr(account[key]);
        });
    }

    const onInputChange = () => {
        upCaseFields();
    }

    if (!user.isActive()) {
        router.go('/account-error')()
    }

    $: if ($user.token && account == null) {
        load();
    }
</script>
<div class="container">
    <div class="mb-5">
        <h1>Ο Λογαριασμός μου</h1>
        <div class="heading-separator"></div>
    </div>

    {#if !$user.token}
        <Warning warning="no-user"/>
    {:else if account != null}

        <form on:submit|preventDefault|stopPropagation={ save }>
            <div class="row">
                <div class="col-lg-6 col-pad-right mb-5">
                    <legend>Στοιχεία μέλους</legend>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>Επίθετο</label>
                                <input type="text" class="form-control" bind:value="{ account.lastname }"
                                       on:change={onInputChange} required>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>Όνομα</label>
                                <input type="text" class="form-control" bind:value="{ account.firstname }"
                                       on:change={onInputChange} required>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>Τηλέφωνο 1</label>
                                <input type="tel" class="form-control" bind:value="{ account.phone1 }">
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>Τηλέφωνο 2</label>
                                <input type="tel" class="form-control" bind:value="{ account.phone2 }">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>Κινητό</label>
                                <input type="tel" class="form-control" bind:value="{ account.mobile }">
                            </div>
                        </div>
                        <div class="col-lg-6">
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>Αρ. Μητρώου</label>
                                <input type="text" class="form-control" value="{ account.code }" readonly>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                                <label>Α.Φ.Μ.</label>
                                <input type="text" class="form-control" bind:value="{ account.afm }">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Διεύθυνση</label>
                        <input type="text" class="form-control" bind:value="{ account.address }"
                               on:change={onInputChange}>
                    </div>
                    <div class="row">
                        <div class="col-lg-5 col-md-8 form-group">
                            <label>Πόλη</label>
                            <input type="text" class="form-control" bind:value="{ account.city }"
                                   on:change={onInputChange}>
                        </div>
                        <div class="col-lg-3 col-md-4 form-group">
                            <label>Τ.Κ.</label>
                            <input type="text" class="form-control" bind:value="{ account.post_code }"
                                   maxlength="5"
                                   oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                            >
                        </div>
                        <div class="col-lg-4 form-group">
                            <label>Νομός</label>
                            <select class="form-select" id="regionId" bind:value="{ account.region_id }"
                                    on:change={ onRegionChange }>
                                <option value="0" disabled selected>επιλογή νομού</option>
                                {#each $app.regions as region}
                                    <option value="{ region.id }">{ region.name }</option>
                                {/each}
                            </select>
                        </div>
                    </div>

                </div>

                <div class="col-lg-6 col-pad-left">
                    <legend>Στοιχεία λογαριασμού</legend>
                    <div class="form-group">
                        <label>Email</label>
                        <input type="email" class="form-control" id="email" bind:value="{ account.email }" required>
                    </div>
                    {#if !showChangePassword}
                        <div class="form-group">
                            <button class="btn btn-link px-0"
                                    on:click|preventDefault|stopPropagation={ toggleChangePassword }>
                                Αλλαγή κωδικού λογαριασμού
                            </button>
                        </div>
                    {:else}
                        <div class="form-group">
                            <label>Νέος κωδικός</label>
                            <PasswordControl id="newPassword" bind:value="{ account.new_password }"/>
                            <button class="btn btn-link px-0"
                                    on:click|preventDefault|stopPropagation={ toggleChangePassword }>
                                Να μην αλλάξει ο κωδικός μου
                            </button>
                        </div>
                    {/if}
                </div>
            </div>
            <hr>
            <div class="text-end">
                <button class="btn btn-primary">Ενημέρωση Αλλαγών</button>
            </div>
        </form>
    {/if}
</div>